/**
 * Maps a current (v4/v5) `AccountInfo` object to the v2-compatible `AccountInfo` format.
 *
 * Strips properties that don't exist in v2, ensuring backward-compatible serialization
 * and type safety when passing account data through the v2 proxy layer.
 *
 * @param account - The current MSAL v4/v5 `AccountInfo` to convert
 * @returns A v2-compatible `AccountInfo` containing only fields recognised by MSAL v2 consumers
 */
export function mapAccountInfo(account) {
    return {
        homeAccountId: account.homeAccountId,
        environment: account.environment,
        tenantId: account.tenantId,
        username: account.username,
        localAccountId: account.localAccountId,
        name: account.name,
        idTokenClaims: account.idTokenClaims,
    };
}
//# sourceMappingURL=map-account-info.js.map